// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__2iXLl","name":"ConsentHeader_name__1Rf0C","birthday":"ConsentHeader_birthday__1K7n9","skeleton":"ConsentHeader_skeleton__tFPo5"};